/**
 * Internal dependencies
 */
import pageConfigs, { getDefaultPage } from '../../pages';

// get URL parameters
const $_GET = [];
window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (a, name, value) => {
	$_GET[name] = value;
});

/**
 * Admin state reducer
 *
 * @param {Object} state - Current state
 * @param {Object} action - Action to process
 * @return {Object} Updated state
 */
function reducer(
	state = {
		activePage: $_GET.sub_page || getDefaultPage(),
	},
	action = {}
) {
	switch (action.type) {
		case 'SET_ACTIVE_PAGE':
			if (state.activePage !== action.activePage) {
				return {
					...state,
					activePage: action.activePage,
				};
			}
			break;
	}

	return state;
}

export default reducer;
